var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ round: _vm.round },attrs:{"id":"cropperImg"}},[_c('img',{ref:"cropperImg",attrs:{"src":_vm.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }